import React from "react"
import { graphql } from "gatsby"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import parse from "html-react-parser"
import { Quote } from "../../icons"
import StructuredText from "../custom-structured-text-renderer"

const PromoTestimonialBlock = ({ title, name, jobTitle, quoteImage, quoteContent, richContent, secondRichContent, mainImage, reverse, button, }) => {
  console.log(quoteContent, name, jobTitle, secondRichContent)
  return (
    <section className={`promo-testimonial-block ${reverse ? "promo-testimonial-block__reverse" : ""}`}>
      <div className="promo-testimonial-block__inner">
        <div className="promo-testimonial-block__title">{title && <h2>{parse(title)}</h2>}</div>
        <div className="promo-testimonial-block__top">
          {title && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}
          <div className="promo-testimonial-block__top-wrapper">
            <div className="promo-testimonial-block__top-content" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
              {mainImage && <Asset asset={mainImage} />}
              {richContent && <StructuredText data={richContent} />}
              {
                button?.length > 0 && button[0]?.title !== 'Available Roles' &&
                <Link
                  className="btn btn--border"
                  to={button[0]?.link[0].externalLink ? button[0]?.link[0].externalLink : button[0]?.link[0].internalLink.permalink}>
                  {button[0]?.title}
                </Link>
              }
              {
                button?.length > 0 && button[0]?.title === 'Available Roles' &&
                <button
                  className="btn btn--border"
                  onClick={button[0]?.title === 'Available Roles' ? () => document.querySelector('#jobs').scrollIntoView({ behavior: 'smooth' }) : null}>
                  {button[0]?.title}
                </button>
              }
            </div>
            <div className="promo-testimonial-block__top-image" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
              {quoteImage && <Asset asset={quoteImage} />}
            </div>
          </div>
        </div>
        <div className="promo-testimonial-block__bottom">
          { (name || jobTitle || secondRichContent) &&
            <div className="promo-testimonial-block__bottom-content">
              <div className="promo-testimonial-block__bottom-quote" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                {quoteImage && <Asset asset={quoteImage} />}
                {name && jobTitle && <Quote />}
                {quoteContent && <StructuredText data={quoteContent} />}
                {name && <h3>{parse(name)}</h3>}
                {jobTitle && <span>{parse(jobTitle)}</span>}
              </div>
              {secondRichContent && <StructuredText data={secondRichContent} />}
            </div>
          }
          <div className="promo-testimonial-block__bottom-image" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
            {mainImage && <Asset asset={mainImage} />}
          </div>
        </div>
      </div>
    </section>
  )
}

export default PromoTestimonialBlock

export const query = graphql`
    fragment PromoTestimonialBlockProps on DatoCmsPromoTestimonialBlock {
      ... on DatoCmsPromoTestimonialBlock {
        id
        jobTitle
        name
        quoteContent {
          value
        }
        quoteImage {
          ...InternalAssetProps
        }
        title
        reverse
        button {
          ...LinkWithTitleProps
        }
        richContent {
          value
        }
        secondRichContent {
          value
        }
        mainImage {
          ...InternalAssetProps
        }
      }
    }
`
